import { Button, styled } from '@mui/material';

const PREFIX = 'SuggestedDate';

export const classes = {
  suggestedDate: `${PREFIX}-suggestedDate`,
};

export const StyledButton = styled(Button)(() => ({
  [`&.${classes.suggestedDate}`]: {
    fontSize: '12px',
    margin: 0,
    color: '#263238',
  },
}));